// ABOUTME: The /jobs/:jobListingRefId route: one job opened from the feed, for talents with PRO_JOB_LISTING on, and
// ABOUTME: the app's not-found screen for everyone else, matching the 404 the backend answers them.
import { useParams } from 'react-router-dom';
import { PageHeader } from 'components/PageHeader';
import { NotFoundErrorScreen } from 'components/screens';
import { getTrans } from 'modules/i18n';
import { JobListingDetail, useJobFeedEnabled } from 'modules/jobListings';
import { Layout } from 'modules/minimal-ui-theme';

export const JobListingDetailPage = () => {
  const { isEnabled, isLoading } = useJobFeedEnabled();
  const { jobListingRefId } = useParams();

  if (isLoading) return null;

  if (!isEnabled || !jobListingRefId) {
    return <NotFoundErrorScreen />;
  }

  return (
    <Layout
      header={<PageHeader title={getTrans('jobs.detail.title')} withBackBtn />}
    >
      <JobListingDetail refId={jobListingRefId} />
    </Layout>
  );
};
